import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    const go = () => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
    go();
    setTimeout(go, 600);
    setTimeout(go, 1200);
  };
  return <section className="pb-6 md:pb-12 px-4 bg-white" data-id="element-141">
      <div className="bg-white border-b border-gray-100 py-2 md:py-4 mb-6 md:mb-10 text-center" data-id="element-142">
        <span className="text-base md:text-xl font-black text-gray-900 tracking-wide" data-id="element-143">
          ✨ 100 CITAS CON MI HIJA
        </span>
      </div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-144">
        <h1 className="text-2xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6 leading-tight" data-id="element-145">
          Menos pantallas, más abrazos: descubrí el poder del Pack 100 Citas con
          mi Hija/o
        </h1>

        <button onClick={scrollToPricing} className="w-3/4 max-w-xs md:w-full md:max-w-lg mx-auto block cursor-pointer md:hover:scale-105 md:transition-transform md:duration-300" data-id="element-146">
          <img src="https://cdn.magicpatterns.com/uploads/3TGnsPowjCqs4XWsH4gxMw/mocap_final_100_citas-removebg-preview_(1).webp" alt="MegaPack 100 Citas con mi Hija" className="w-full h-auto md:drop-shadow-2xl mb-5 md:mb-8 rounded-xl" fetchPriority="high" decoding="auto" loading="eager" sizes="(max-width: 768px) 75vw, 512px" width={1080} height={1080} style={{
          aspectRatio: '1/1',
          objectFit: 'contain'
        }} data-id="element-147" />
        </button>

        <div className="bg-yellow-100 border-l-4 border-yellow-500 p-3 md:p-4 mb-5 md:mb-8 text-left md:text-center" data-id="element-148">
          <p className="text-sm md:text-xl font-medium text-gray-800" data-id="element-149">
            100 citas familiares únicas para jugar, conectar y crear recuerdos
            inolvidables juntos. Cada cita incluye espacio para pegar fotos y
            guardar el recuerdo. Sin planear por horas. Sin gastar de más. Solo
            elegí una cita y empezá a disfrutar.
          </p>
        </div>

        <div className="max-w-md mx-auto" data-id="element-150">
          <CTAButton text="✨ QUIERO MI PACK DE CITAS AHORA" subtext="📄 100% Digital • ⚡ Acceso inmediato • 🛡️ Garantía 7 días" size="sm" data-id="element-151" />
        </div>
      </div>
    </section>;
}